import { types } from 'mobx-state-tree';
import { createContext } from 'react';
import { account } from 'src/stores/account';
import { addNewProperty } from 'src/stores/addNewProperty';
import { admin } from 'src/stores/admin';
import { allocations } from 'src/stores/allocations';
import { amenities } from 'src/stores/amenities';
import { auth } from 'src/stores/auth';
import { company } from 'src/stores/company';
import { corrections } from 'src/stores/corrections';
import { fse } from 'src/stores/fse';
import { portfolios } from 'src/stores/portfolios';
import { properties } from 'src/stores/properties';
import { fees } from 'src/stores/fees';
import { teamMembers } from 'src/stores/teamMembers';
import { units } from 'src/stores/units';
import { utilityProviders } from 'src/stores/utilityProviders';
import { buildings } from 'src/stores/buildings';
import { chargeExportTemplates } from 'src/stores/chargeExportTemplates';
import { enrollResident } from 'src/stores/enrollResident';
import { residencies } from 'src/stores/residencies';
import { activity } from 'src/stores/residencyActivityLogs';
import { files } from 'src/stores/fileApi';
import { fileCabinet } from 'src/stores/fileCabinet';
import { inUnitAmenities } from 'src/stores/inUnitAmenities';
import { invoice } from 'src/stores/invoice';
import { resident } from 'src/stores/resident';
import { roommates } from 'src/stores/roommates';
import { payment } from 'src/stores/payment';
import { report } from 'src/stores/report';
import { statement } from 'src/stores/statement';
import { transaction } from 'src/stores/transaction';
import { address } from 'src/stores/address';
import { notifications } from 'src/stores/notifications';
import { hubspot } from 'src/stores/hubspot';
import { propertyUtility } from 'src/stores/propertyUtility';
import { residenciesMultiActionStore } from 'src/stores/residenciesMultiAction';
import { tags } from 'src/stores/tags';
import { urjanet } from 'src/stores/urjanet';
import { credentials } from 'src/stores/credentials';
import { portfoliosMultiActionStore } from 'src/stores/portfoliosMultiAction';
import { homeDashboardStore } from 'src/stores/homeDashboard';
import { vendors } from 'src/stores/vendors';
import { appfolioBillsApi } from 'src/stores/appfolio/bills';
import { appfolioGlAccounts } from 'src/stores/appfolio/glAccounts';
import { appfolioPropertiesApi } from 'src/stores/appfolio/properties';
import { stripe } from 'src/stores/stripe';
import { billAutomationBillsApi } from 'src/stores/billAutomation/bills';
import { allowedSenders } from 'src/stores/billAutomation/allowedSenders';
import { appfolioPush } from 'src/stores/billAutomation/appfolioPush';
import { bulkUpload } from 'src/stores/billAutomation/bulkUpload';
import { companyBills } from 'src/stores/billAutomation/companyBills';
import { uploadedBills } from 'src/stores/billAutomation/uploadedBills';
export const RootStore = types.model('RootStore', {
  account,
  activity,
  addNewProperty,
  admin,
  address,
  allocations,
  amenities,
  auth,
  buildings,
  chargeExportTemplates,
  company,
  corrections,
  enrollResident,
  fees,
  fileCabinet,
  files,
  fse,
  inUnitAmenities,
  invoice,
  payment,
  portfolios,
  properties,
  report,
  residencies,
  resident,
  roommates,
  statement,
  teamMembers,
  transaction,
  units,
  utilityProviders,
  notifications,
  hubspot,
  propertyUtility,
  residenciesMultiActionStore,
  tags,
  urjanet,
  credentials,
  portfoliosMultiActionStore,
  homeDashboardStore,
  vendors,
  appfolioBillsApi,
  appfolioGlAccounts,
  appfolioPropertiesApi,
  stripe,
  billAutomationBillsApi,
  allowedSenders,
  appfolioPush,
  bulkUpload,
  companyBills,
  uploadedBills
});
const initialState = RootStore.create();
export const rootStore = initialState;
export const rootStoreContext = /*#__PURE__*/createContext(rootStore);
export const RootStoreProvider = rootStoreContext.Provider;